<template>
  <vs-popup full-screen class="shipment-delivery-note-pop-up"
            id="popup"
            :title="`${credit_note_code} Credit Note`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="24">
          <pdf ref="myPdfComponent" class="object-scale-down" :src="file" ></pdf>
        </vs-col>
      </vs-row>

      <div class="flex flex-wrap items-center justify-end mt-8">
        <vs-button @click="onClickDownload" button="submit" icon-pack="feather" icon="icon-download-cloud" color="primary" class="ml-auto mt-2">Download</vs-button>
        <vs-button @click="$refs.myPdfComponent.print()" button="submit" icon-pack="feather" icon="icon-printer" color="danger" class="ml-2 mt-2">Print</vs-button>
      </div>

      <span style="display: none">{{file}}</span>
    </vx-card>
  </vs-popup>
</template>

<script>
  import pdf from 'vue-pdf'
  import axios from "@/axios";
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      credit_note_code: '',
      file: ''
    }
  }

  export default {
    name: 'ShipmentDeliveryNoteDocumentPopUp',
    data () {
      return initialState()
    },
    methods:{
      async onClickDownload() {
        window.open(this.file);
      },
      async openPopup (id, credit_note_code) {
        try {
          await Object.assign(this.$data, initialState())
          this.credit_note_code = credit_note_code
          this.id = id
          await this.getRmOrderItemLabel()
        } catch (error) {

        }
      },
      async getRmOrderItemLabel() {
        this.$vs.loading()
        try {
          axios(`admin/customer/customer_credit_note/${this.id}/pdf`, {
            method: 'GET',
            responseType: 'blob'
          })
            .then(response => {
              //Create a Blob from the PDF Stream
              const file = new Blob(
                [response.data],
                {type: 'application/pdf'});
              //Build a URL from the file
              this.file = URL.createObjectURL(file)
              this.open = true;
              this.$vs.loading.close()
              //Open the URL on new Window
            })
        } catch (e) {
          this.$vs.loading.close()
        }
      },
    },
    components: {
      pdf
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .shipment-delivery-note-pop-up >>> .vs-popup {
    /*min-height: 78% !important;*/
    /*min-width: 60% !important;*/
  }

</style>
